if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        // Thumbnail .product__media-toggle is display:none on this PDP; focusing it lands on BODY.
        this.openedBy = this.visibleOpenedBy(this.openedBy);
        super.hide();
      }

      isShown(element) {
        return !!(element && element.getClientRects && element.getClientRects().length);
      }

      visibleOpenedBy(opener) {
        if (this.isShown(opener)) return opener;
        const host =
          (opener && typeof opener.closest === 'function' &&
            (opener.closest('modal-opener') ||
              opener.closest('.product__media-item') ||
              opener.closest('[data-media-id]'))) ||
          document.querySelector('modal-opener.product__modal-opener');
        if (!this.isShown(host)) return opener;
        if (!host.hasAttribute('tabindex')) host.tabIndex = -1;
        return host;
      }

      show(opener) {
        this.loadDeferredMedia();
        super.show(opener);
        this.showActiveMedia();
        const dialog = this.querySelector('[role="dialog"]');
        if (dialog) {
          // trapFocus only listens for Tab after focusin. super.show already focused the dialog.
          if (document.activeElement === dialog) dialog.blur();
          trapFocus(dialog, dialog);
        }
      }

      loadDeferredMedia() {
        const content = this.querySelector('.product-media-modal__content');
        const template = content && content.querySelector(':scope > template.product-media-modal__stage');
        if (!template) return;
        content.append(template.content);
        template.remove();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
